<template lang="html">
  <div class="">
    <div class="task__table-head">
    </div>

    <container @drop="onSort">
      <draggable v-for="task in value" :key="task.task_id" class="task__list">
        <v-layout row wrap align-end>
          <v-flex sm9 xs12 class="task__name">
            <span>
              <router-link class="project-name caption" :to="{name: 'ProjectOverview', params: {id: task.project_id}}">
                {{ task.project_name }}
              </router-link>

              <div class="task-name" @click="navigateToTaskDetails(task.task_id)">
                {{ task.task_name || task.task_ref || task.task_id }}
              </div>
            </span>
          </v-flex>
          <v-flex sm3 xs12 class="task__metrics">
            <span>
              <span class="sub-headers">{{ timeToStart(task) }}</span>
              <v-icon title="Time to Start" class="icon--grey small-icon">timelapse</v-icon>
            </span>
            <span v-if="task.task_length">
              <span class="sub-headers">{{ duration(task) }}</span>
              <v-icon title="Duration" class="clock-grey-icon small-icon"></v-icon>
            </span>
          </v-flex>
        </v-layout>
      </draggable>
    </container>

  </div>
</template>


<script>
import moment from 'moment';
import { Container, Draggable } from 'vue-smooth-dnd';
import { applyDrag } from '@/utils/dnd';

export default {
  components: {
    Container,
    Draggable,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
  },
  methods: {
    onSort({ removedIndex, addedIndex }) {
      const tasks = this.value;
      const sortedTasks = applyDrag(tasks, removedIndex, addedIndex);
      this.$emit('input', sortedTasks);
    },
    timeToStart(task) {
      if (!task.task_date) return 'ongoing';
      return moment(task.task_date).fromNow();
    },
    duration(task) {
      if (!task.task_length) return '-';
      const minutes = parseInt(task.task_length, 10);
      return moment().add(minutes, 'minutes').fromNow(true);
    },
    navigateToTaskDetails(taskId) {
      this.$router.push({ name: 'TaskDetails', params: { id: taskId } });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

#app {
  .icon--grey {
    color: #bbc2c8;
  }

  .task__list {
    padding: 15px 10px;
    border-bottom: 1px solid $filter-background;
  }

  .task_duration, .task_start_time {
    padding-left: 10px;
    color: $placeholder;
  }

  .task__name {
    font-size: 16px;
    color: $blue;
  }

  .sub-headers {
    font-size: 12px;
    color: $placeholder;
  }

  .task__metrics > span {
    display: inline-block;
  }

  .task__metrics > span::after {
    content: '\00B7';
    color: $placeholder;
    font-weight: bold;
    margin: 0 10px;
  }

  .task__metrics > span:last-child::after {
    display: none;
  }

  .task-name {
    font-size: 16px;
    color: $blue;
    cursor: pointer;
  }

  .project-name {
    color: $light;
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/TasksList.vue